<div class="container container-shadow">
  <div class="page-header">
    <h2 class="pt-3">Settings</h2>
  </div>
  <hr />
  <div class="row">
    <div class="col-sm-1 col-md-1 d-none d-sm-block"></div>
    <div class="col-12 col-sm-9 col-md-7">
      <div class="card">
        <div class="card-header">
          <a style="cursor: pointer" (click)="toggleForm()"><i class="fas" [ngClass]="{ 'fa-plus-circle': !addingSetting, 'fa-minus-circle': addingSetting }"></i> New Setting</a>
        </div>
        <div class="card-body" *ngIf="addingSetting">
          <app-setting-form [setting_id]="undefined" (formEvent)="onSettingFormEvent($event)"></app-setting-form>
        </div>
      </div>
      <hr />
    </div>
  </div>
  <div class="row">
    <div class="col-sm-1 col-md-1 d-none d-sm-block"></div>
    <div class="col-12 col-sm-9 col-md-7 mb-2">
      <div class="form-inline">
        <label>Show settings for the group - &nbsp;</label>
        <select [(ngModel)]="selectedSettingGroupId" (change)="getSettings()" class="form-control input-sm" placeholder="Setting Group">
          <option *ngFor="let settingGroup of settingGroups" [value]="settingGroup.id">{{ settingGroup.name }}</option>
        </select>
      </div>
    </div>
  </div>
  <table class="table">
    <thead>
      <tr>
        <th>Id</th>
        <th>Setting Type</th>
        <th>Value</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let setting of settings">
        <td>{{ setting.id }}</td>
        <td *ngIf="!editingSettings[setting.id]">
          <strong>{{ setting.setting_type.name }}</strong>
          <br />
          <span>{{ setting.setting_type.description }}</span>
        </td>
        <td *ngIf="!editingSettings[setting.id]">{{ setting.value }}</td>
        <td *ngIf="!editingSettings[setting.id]">
          <div class="btn-group btn-group-sm">
            <button title="edit" type="button" class="btn btn-primary btn-sm" (click)="editingSettings[setting.id] = true"><i class="fas fa-pencil-alt"></i></button>
            <button title="delete" type="button" (click)="deleteSetting(setting)" class="btn btn-danger btn-sm"><i class="fas fa-trash"></i></button>
          </div>
        </td>
        <td colspan="2" *ngIf="editingSettings[setting.id]">
          <app-setting-form [setting_id]="setting.id" (formEvent)="onSettingFormEvent($event, setting)"></app-setting-form>
        </td>
        <td *ngIf="editingSettings[setting.id]"></td>
      </tr>
    </tbody>
  </table>
</div>
